export default "__VITE_ASSET__DelkdwKj__"